import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AccordionSection } from '@scalefast/core';
import { AnalyticsStoreService } from '../../services';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  standalone: true,
  imports: [NgClass],
})
export class AppAccordionComponent implements OnInit {
  private _sections: Array<any> = [];
  @Input() oppenedDefault: boolean = true;
  @Input() set sections(sections: Array<AccordionSection>) {
    if (!sections || sections.length === 0) {
      return;
    }
    this._sections = sections.map((section: any) => ({
      ...section,
      active: false,
    }));
  }
  constructor(private analyticsStoreService: AnalyticsStoreService) {}

  ngOnInit(): void {
    if (this.oppenedDefault) {
      this._sections[0].active = true;
    }
  }

  get sections(): Array<any> {
    return this._sections;
  }

  setActiveItem(item: any) {
    const itemNewActiveValue = !item.active;
    this.sections.forEach((section: any) => (section.active = false));
    item.active = itemNewActiveValue;
  }

  gtmEvent(event: any): void {
    const category = event.target.getAttribute('data-gtmcategory');
    const action = event.target.getAttribute('data-gtmaction');
    const label = event.target.getAttribute('data-gtmlabel');
    this.analyticsStoreService.miscEvent(category, action, label);
  }
}
